import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { useGetAllJournalEntriesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { CalendarDatePicker } from "shared/UI/DatePicker/CalendarDatePicker/CalendarDatePicker";
import { CalendarTheme } from "shared/UI/DatePicker/enum";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";

export const JournalCalendar = () => {
  const navigate = useNavigate();
  const { handlePositiveMoment } = useAppReviewContext();
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const fromDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).toDateOnlyString();
  const toDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).toDateOnlyString();

  const { data } = useGetAllJournalEntriesFunctionRequest({
    userFromDate: fromDate,
    userToDate: toDate,
    xClientCode: ClientInfoState.getCode(),
  });

  const allEntriesDates = data?.entries.map((entry) => new Date(entry.date)) ?? [];

  const handleSetDate = (date: Date) => {
    const entry = data?.entries.find((entry) => entry.date === date.toDateOnlyString());

    if (entry) {
      handlePositiveMoment();
      navigate("entry", {
        state: entry,
      });
    } else {
      navigate("create", {
        state: { date: date.toDateOnlyString() },
      });
    }
  };

  return (
    <CalendarDatePicker
      disableSelect
      theme={CalendarTheme.Secondary}
      highlightDates={allEntriesDates}
      setDate={handleSetDate}
      maxDate={new Date()}
      onMonthChange={setCurrentMonth}
    />
  );
};
